import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import styled from "@emotion/styled";

// Redux
import { connect } from "react-redux";
import { getUserInfo } from "redux/selectors";

// Common
import COLORS from "common/Colors";
import { DEVICE } from "common/Device";

// Components
import Button from "atoms/Button";
import LeaveForm from "organisms/LeaveForm";

// --- Office -> IANA timezone map ---
const OFFICE_TIMEZONES = {
  Armenia: "Asia/Yerevan",
  Kenya: "Africa/Nairobi",
  India: "Asia/Kolkata",
  // add more offices as needed
};
const DEFAULT_TIMEZONE = "Africa/Nairobi"; // fallback if office not in map // fallback if office not in map

// --- Hook: live clock for the given office ---
function useOfficeClock(managingOffice) {
  const timeZone = OFFICE_TIMEZONES[managingOffice] || DEFAULT_TIMEZONE;
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30 * 1000); // refresh every 30s
    return () => clearInterval(timer);
  }, []);

  const timeParts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(now);

  const hour = timeParts.find((p) => p.type === "hour")?.value;
  const minute = timeParts.find((p) => p.type === "minute")?.value;
  const ampm = timeParts.find((p) => p.type === "dayPeriod")?.value;

  const longDay = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(now);

  return { time: `${hour}:${minute}`, ampm, longDay };
}

const StyledRow = styled(Row)`
  margin-top: -0.9rem;
  margin-left: 2rem;
  padding-top: 5px;
  .align-left {
    display: flex;
    flex-direction: column;
    @media ${DEVICE.tablet} {
      margin-top: 3rem;
    }
    @media (max-width: 426px) {
      margin-top: 5rem;
    }
  }
`;

const StyledTime = styled.span`
  font-size: 1.2rem;
  color: ${COLORS.TEXT.SECONDARY};
  font-weight: bold;
`;

const StyledAMPM = styled.span`
  color: ${COLORS.TEXT.SECONDARY};
  font-size: 12px;
  padding-left: 10px;
  font-weight: 600;
  white-space: nowrap;
  @media ${DEVICE.tablet} {
    font-size: 10px;
    margin-left: -10px;
  }
  @media ${DEVICE.mobileL} {
    font-size: 10px;
  }
`;

const StyledDate = styled.div`
  color: ${COLORS.TEXT.SECONDARY};
  font-size: 12px;
  margin-top: -45px;
  white-space: nowrap;
  @media ${DEVICE.tablet} {
    font-size: 8px;
    margin-left: -10px;
  }
`;

function DashboardTop({ userInfo }) {
  const [displayLeaveModal, toggleLeaveModal] = useState(false);

  // managingoffice is an array, e.g. ["Armenia"] — take the first entry
  const managingOffice = userInfo?.managingoffice?.[0];

  const { time, ampm, longDay } = useOfficeClock(managingOffice);

  return (
    <>
      <StyledRow>
        <Col xs={24} md={4} sm={24} className="align-left">
          <div>
            <StyledTime>{time}</StyledTime>
            <StyledAMPM>{ampm}</StyledAMPM>
          </div>
          <StyledDate>{longDay}</StyledDate>
        </Col>
      </StyledRow>
      <LeaveForm
        isModalVisible={displayLeaveModal}
        closeModal={() => toggleLeaveModal(false)}
        leaveDetails={{}}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(DashboardTop);